import { render, staticRenderFns } from "./tvWidget.vue?vue&type=template&id=6432ee95&scoped=true"
import script from "./tvWidget.vue?vue&type=script&lang=js"
export * from "./tvWidget.vue?vue&type=script&lang=js"
import style0 from "./tvWidget.vue?vue&type=style&index=0&id=6432ee95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6432ee95",
  null
  
)

export default component.exports